/* eslint-disable no-useless-escape */
import React from "react";
import html2pdf from "html2pdf.js";
import "../styles/styles.css"; // Import the print styles CSS file
import { isIpad } from "../constant/StaffOnboardState";

export function isNullOrEmpty(value) {
  if (
    value === undefined ||
    value === null ||
    value === "" ||
    value === "NULL"
  ) {
    return true;
  }
  if (typeof value === "object" && Object.keys(value).length === 0) {
    return true;
  }
  return false;
}

export const generatePdf = async (printComponentRef, filename) => {
  const html = printComponentRef?.current.cloneNode(true);
  if (html) {

    // Temporarily hide the elements to be ignored
    const elementsToIgnore = html.querySelectorAll(
      ".footerBtn, .no-print",
      "starGrey"
    );
    elementsToIgnore.forEach((element) => {
      element.style.display = "none";
    });

    const elementsMuiGridItem = html.querySelectorAll(".MuiGrid-item , .footerText, .formSection, .formSectionTitle, .companyHeaderContainer, .mainBody");
    
    elementsMuiGridItem.forEach((element) => {
      element.classList.add("pdfStyle");
    });
    
    const options = {
      margin: 0, // Set margins to 0
      filename: `${filename}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        width: 800,
        scale: 2
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
      pagebreak: {
        mode: ["css"],
        before: [".pageBreak", "#pageBreak", ".before"],
      },
    };

    const pdf = await html2pdf().from(html).set(options).toPdf().get("pdf");

    // Restore the elements after generating the PDF
    elementsToIgnore.forEach((element) => {
      element.style.display = "";
    });

    elementsMuiGridItem.forEach((element) => {
      element.classList.remove("pdfStyle");
    });

    if (!pdf) {
      throw new Error("Failed to generate PDF");
    }
    return pdf;
  }
};

export function signatureRawToJSON(data) {
  try {
    if (
      !data.props ||
      !data.props.children ||
      !data.props.children.props ||
      !data.props.children.props.children ||
      !data.props.children.props.children.length
    )
      throw new Error("incorrect raw format");

    let paths = [];

    if (data.props.children.props.children[0].length) {
      data.props.children.props.children[0].forEach((stroke) => {
        if (
          !stroke.props ||
          !stroke.props.children ||
          !stroke.props.children.props ||
          !stroke.props.children.props.d
        )
          throw new Error("incorrect raw format in stroke stack");

        paths = paths.concat(
          stroke.props.children.props.d.match(/([ML] -?[\d\.]+,-?[\d\.]+)/g)
        );
      });
    }

    if (
      !data.props.children.props.children[1].props ||
      !data.props.children.props.children[1].props.d
    )
      throw new Error("incorrect raw format in last stroke");
    paths = paths.concat(
      data.props.children.props.children[1].props.d.match(
        /([ML] -?[\d\.]+,-?[\d\.]+)/g
      )
    );

    if (!paths.length) throw new Error("incorrect raw format, empty paths");

    let result = [];

    let mx, my;

    paths.forEach((path) => {
      const pathData = path.match(/([ML]) (-?[\d\.]+),(-?[\d\.]+)/);
      if (pathData[1] === "M") {
        mx = Math.round(pathData[2]);
        my = Math.round(pathData[3]);
      } else if (pathData[1] === "L") {
        result.push({
          lx: Math.round(pathData[2]),
          ly: Math.round(pathData[3]),
          mx: mx,
          my: my,
        });
        mx = Math.round(pathData[2]);
        my = Math.round(pathData[3]);
      }
    });

    return JSON.stringify(result);
  } catch (error) {
    console.error(`Cannot generate signature JSON: , error: ${error}`);
    return "";
  }
}

export const prepareData = (data) => {
  let resultArray = [];

  if (isNullOrEmpty(data) || data.length <= 0) return null;

  data.forEach((x) => {
    let middlePoint = x[0];
    let multiplier = 1;
    let d = [`M ${middlePoint.x},${middlePoint.y}`];

    let collector = x
      .map((chunk) => {
        if (chunk.x !== middlePoint.x && chunk.y !== middlePoint.y) {
          let xNext = chunk.x * multiplier;
          let yNext = chunk.y * multiplier;
          return `L ${xNext},${yNext}`;
        }
      })
      .filter(Boolean);

    let result = d.concat(collector).join(" ");
    resultArray.push(result);
  });

  return resultArray;
};

export const CreateComponents = (pointGroups) => {
  let listWithoutLast = prepareData(pointGroups);
  listWithoutLast = listWithoutLast.slice(0, -1);
  return listWithoutLast.map((path, i) => {
    return (
      <React.Fragment key={`path-${i}`}>
        <path d={path} stroke="#145394" strokeWidth="2" fill="none" />
      </React.Fragment>
    );
  });
};

export const createSvgPath = (signaturePicture) => {
  if (!isNullOrEmpty(signaturePicture) && signaturePicture.length > 0) {
    return prepareData(signaturePicture).join(" ");
  } else return null;
};

export const createSignSvgTemplate = (pointGroups, svgSpec) => {
  if (isNullOrEmpty(pointGroups) || pointGroups.length <= 0) return null;

  return (
    <svg
      width={svgSpec.svgWidth}
      height={svgSpec.svgHeight}
      style={{ backgroundColor: "transparent" }}
      preserveAspectRatio={"xMidYMid meet"}
      viewBox={`0 0 ${svgSpec.svgWidth} ${svgSpec.svgHeight}`}
      key={"svgTemplate"}
    >
      <g>
        {CreateComponents(pointGroups)}
        <path
          d={prepareData(pointGroups)[prepareData(pointGroups).length - 1]}
          id="Shape"
          stroke="#145394"
          strokeWidth="2"
          fill="none"
          key={`path-${prepareData(pointGroups).length - 1}-last`}
        />
      </g>
    </svg>
  );
};

export const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

export const getFirstNonEmptyValue = (...values) => {
  for (const value of values) {
    if (!isNullOrEmpty(value)) {
      return value;
    }
  }
  return null;
};

export const RenderArea = (v) => {
  if (v === "hkOffice") return "香港辦公室";
  if (v === "hkShop") return "香港分店";
  return "-";
};

export const RenderPadding = (isPrint) => {
  if (isPrint && !isIpad()) {
    return "0";
  } else if (!isPrint && isIpad()) {
    return "2rem";
  } else {
    return "2rem";
  }
};

export const transformFormErrors = (errors) => {
  if (!errors) return {};
  return (
    Object.entries(errors)?.reduce((acc, [key, messages]) => {
      acc[key] = { message: messages[0] };
      return acc;
    }, {}) || {}
  );
};
